
import React from 'react';
import { getColorForElement, calculateMisalignments } from '@/utils/debug/debugUtils';

interface ElementPosition {
  element: string;
  top: number;
  left: number;
  width: number;
  height: number;
}

interface DebugInfoPanelProps {
  elementPositions: ElementPosition[];
  currentOffset: number | null;
}

/**
 * Panel displaying debug information about layers and touch offset
 */
export const DebugInfoPanel: React.FC<DebugInfoPanelProps> = ({ 
  elementPositions,
  currentOffset
}) => {
  return (
    <div 
      className="layer-debug-panel"
      style={{
        position: 'fixed',
        top: '10px',
        left: '10px',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
        padding: '8px',
        borderRadius: '4px',
        fontSize: '12px',
        maxWidth: '80%',
        maxHeight: '50%',
        overflow: 'auto',
        zIndex: 9999
      }}
    >
      <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>Layer positions:</div>
      {elementPositions.map((pos, index) => (
        <div key={index} style={{ marginBottom: '4px' }}>
          <span style={{ 
            display: 'inline-block', 
            width: '12px', 
            height: '12px', 
            backgroundColor: getColorForElement(pos.element),
            marginRight: '4px'
          }}></span>
          <span>{pos.element}: (T:{pos.top}, L:{pos.left}, W:{pos.width}, H:{pos.height})</span>
        </div>
      ))}
      
      <div style={{ marginTop: '8px', fontWeight: 'bold' }}>Misalignments:</div>
      {calculateMisalignments(elementPositions).map((misalignment, index) => (
        <div key={`misalignment-${index}`} style={{ marginBottom: '4px', color: 'orange' }}>
          {misalignment}
        </div>
      ))}
      
      <div style={{ marginTop: '8px', fontWeight: 'bold' }}>Touch Offset:</div>
      <div>
        {currentOffset !== null 
          ? `Currently using ${currentOffset}px offset` 
          : 'Detecting optimal offset...'}
      </div>
      <div style={{ fontSize: '10px', marginTop: '4px', color: '#aaa' }}>
        Use controls in bottom right to adjust offset
      </div>
    </div>
  );
};
